import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { getAllDepartments } from '../data/department';
import {
  Box,
  Paper,
  Typography,
  IconButton,
 Container,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
} from '@mui/material';

import {
  Delete as DeleteIcon,
  Add as AddIcon,
  Search as SearchIcon,
 
  
} from '@mui/icons-material';
import { ErrorMessage } from '../Message';

function Department() {
    
      const [searchTerm, setSearchTerm] = useState('');
      const [departments, setDepartments] = useState(getAllDepartments);
    
    
    
         const handleDelete = (id) => {
       // setDepartments(departments.filter(dept => dept.id !== id));
       ErrorMessage('Error' ,'Department Cannot Be Deleted')
      };
    
      const handleCreateDepartment = () => {
        // This would typically open a modal or navigate to a form
        console.log('Create Department clicked');
      };
    
      const filteredDepartments = departments.filter(dept =>
        dept.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        dept.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    

  return (
    <div>
         <Container maxWidth="xl" sx={{ py: 4 }}>
                         {/* Header */}
                          <Box sx={{ mb: 4 }}>
                           <Box sx={{ 
                             display: 'flex', 
                             flexDirection: { xs: 'column', md: 'row' },
                             justifyContent: { md: 'space-between' }, 
                             alignItems: { xs: 'stretch', md: 'center' },
                             gap: { xs: 2, md: 0 },
                             mb: 3
                           }}>
                             <Typography 
                               variant="h4" 
                               component="h1" 
                               sx={{ 
                                 fontWeight: 600,
                                 color: '#2c3e50',
                                 fontSize: { xs: '1.75rem', sm: '2rem', md: '2.125rem' },
                                 textAlign: { xs: 'center', md: 'left' },
                                 mb: { xs: 1, md: 0 }
                               }}
                             >
                               Department Management
                             </Typography>
                             
                             <Box sx={{ 
                               display: 'flex', 
                               flexDirection: { xs: 'column', sm: 'row' },
                               gap: { xs: 1.5, sm: 2 }, 
                               alignItems: { xs: 'stretch', sm: 'center' },
                               width: { xs: '100%', md: 'auto' }
                             }}>
                               <TextField
                                 placeholder="Search departments..."
                                 variant="outlined"
                                 size="small"
                                 value={searchTerm}
                                 onChange={(e) => setSearchTerm(e.target.value)}
                                 InputProps={{
                                   startAdornment: <SearchIcon sx={{ color: '#757575', mr: 1 }} />
                                 }}
                                 sx={{ 
                                   minWidth: { xs: 'auto', sm: 800, md: 900 },
                                   width: { xs: '100%', sm: 'auto' },
                                   '& .MuiOutlinedInput-root': {
                                     borderRadius: 2
                                   }
                                 }}
                               />
                               
                              
                             </Box>
                           </Box>
                         </Box>
                   
                         {/* Department Grid */}
                         <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }} >
                           {filteredDepartments.map((department) => (
                             <Grid item xs={12} sm={6} md={4} key={department.id} size={4}>
                               <Paper
                                 elevation={1}
                                 sx={{
                                   height: '100%',
                                   borderRadius: 3,
                                   transition: 'all 0.2s ease-in-out',
                                   border: '1px solid #e5e7eb',
                                   '&:hover': {
                                     elevation: 4,
                                     transform: 'translateY(-2px)',
                                     boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
                                   }
                                 }}
                               >
                                 <Card sx={{ 
                                   height: '100%', 
                                   boxShadow: 'none',
                                   borderRadius: 3
                                 }}>
                                   <CardContent sx={{ 
                                     p: 3,
                                     position: 'relative',
                                     height: '100%',
                                     display: 'flex',
                                     flexDirection: 'column'
                                   }}>
                                     {/* Delete Button */}
                                     <IconButton
                                       onClick={() => handleDelete(department.id)}
                                       sx={{
                                         position: 'absolute',
                                         top: 12,
                                         right: 12,
                                         color: '#ef4444',
                                         p: 1,
                                         '&:hover': {
                                           backgroundColor: '#fef2f2',
                                           color: '#dc2626'
                                         }
                                       }}
                                       size="small"
                                     >
                                       <DeleteIcon fontSize="small" />
                                     </IconButton>
                   
                                     {/* Department Content */}
                                     <Box sx={{ flex: 1, pr: 2 }}>
                                       <Typography
                                         variant="h6"
                                         component="h3"
                                         sx={{
                                           fontWeight: 600,
                                           color: '#1f2937',
                                           mb: 2,
                                           fontSize: '1.1rem',
                                           lineHeight: 1.3
                                         }}
                                       >
                                         {department.name}
                                       </Typography>
                                       
                                       <Typography
                                         variant="body2"
                                         color="text.secondary"
                                         sx={{
                                           color: '#6b7280',
                                           lineHeight: 1.5,
                                           fontSize: '0.9rem'
                                         }}
                                       >
                                         {department.description}
                                       </Typography>
                                     </Box>
                                   </CardContent>
                                 </Card>
                               </Paper>
                             </Grid>
                           ))}
                         </Grid>
                   
                         {/* No Results */}
                         {filteredDepartments.length === 0 && (
                           <Box sx={{ 
                             textAlign: 'center', 
                             py: 8,
                             color: '#6b7280'
                           }}>
                             <Typography variant="h6" sx={{ mb: 1 }}>
                               No departments found
                             </Typography>
                             <Typography variant="body2">
                               Try adjusting your search terms
                             </Typography>
                           </Box>
                         )}
                       </Container>
    </div>
  )
}

export default Department